<div class="rules-group-container">

    <div class="rules-list" *ngFor="let rule of rules; let i = index; let first = first; let last = last">
        <sfx-filters-rule [entity]="entity" [group]="group" [index]="rule.index" [appliedRule]="rule" [first]="first"
            [last]="last" [filterFields]="filterFields" [fixedRule]="!!fixedFilters"
            [deleteRule]="getRemoveRuleFn(rule.index)" [onRuleUpdate]="getOnRuleUpdateFn(rule.index)"
            [onApply]="onApply">
        </sfx-filters-rule>
    </div>

    <div>
        <button [disabled]="fixedFilters" [style.visibility]="!fixedFilters ? 'visible' : 'hidden'"
            [style.pointer-events]="!fixedFilters ? 'auto' : 'none'" mat-button id="add-rule-btn"
            (click)="addFilterRule()" color="primary">
            <mat-icon id="icon-add-rule" fontSet="salesflare" color="primary" fontIcon="sf-icon-add"
                class="icon-24"></mat-icon>
            <span translate>Add filter</span>
        </button>
    </div>

</div>